export const FRONT_CHAT_SCRIPT_URL = 'https://chat-assets.frontapp.com/v1/chat.bundle.js';
export const FRONT_CHAT_SCRIPT_ID = 'front-chat-script';
export const FRONT_CHAT_ID = 'd69a70f77c0b299497c1633abdbf410b';

export const DEFAULT_USE_LAUNCHER = true;

export const IDENTIFY_USER_DELAY = 2000;
